import React from "react";
import ReactDOM from "react-dom";
import "styles/main.scss";
import App from "./App";
import { Log } from 'oidc-client-ts';

Log.setLogger(console);

ReactDOM.render(<App />, document.getElementById("root"));
